
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1mzlz_17",
  "full-width": "awsui_full-width_8cbea_1mzlz_44",
  "refresh": "awsui_refresh_8cbea_1mzlz_47",
  "disabled": "awsui_disabled_8cbea_1mzlz_53",
  "selected": "awsui_selected_8cbea_1mzlz_116",
  "icon": "awsui_icon_8cbea_1mzlz_127",
  "with-text": "awsui_with-text_8cbea_1mzlz_131",
  "with-no-text": "awsui_with-no-text_8cbea_1mzlz_140",
  "root": "awsui_root_8cbea_1mzlz_145",
  "segment-part": "awsui_segment-part_8cbea_1mzlz_177",
  "grouped": "awsui_grouped_8cbea_1mzlz_202",
  "grouped-only": "awsui_grouped-only_8cbea_1mzlz_202",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_1mzlz_206",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_1mzlz_221",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_1mzlz_225",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_1mzlz_231",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_1mzlz_235",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_1mzlz_239",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_1mzlz_245",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_1mzlz_249",
  "with-error": "awsui_with-error_8cbea_1mzlz_253",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_1mzlz_281",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_1mzlz_281",
  "with-warning": "awsui_with-warning_8cbea_1mzlz_287",
  "grouped-validation-first": "awsui_grouped-validation-first_8cbea_1mzlz_329",
  "select": "awsui_select_8cbea_1mzlz_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_1mzlz_351",
  "segment-count-3": "awsui_segment-count-3_8cbea_1mzlz_358",
  "segment-count-4": "awsui_segment-count-4_8cbea_1mzlz_365",
  "segment-count-5": "awsui_segment-count-5_8cbea_1mzlz_372",
  "segment-count-6": "awsui_segment-count-6_8cbea_1mzlz_379",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1mzlz_386"
};
  